import React, { useEffect, useState } from 'react';
import SidebarLayout from '../../components/SidebarLayout';
import '../VisualsPage/styles.css';
import { API_BASE_URL as API_URL } from '../../config/apiBase';


const UploadPage = () => {
  const [schemas, setSchemas] = useState([]);
  const [selectedSchema, setSelectedSchema] = useState('');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [file, setFile] = useState(null);

  useEffect(() => {
    fetchSchemas();
  }, []);

  const fetchSchemas = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/visuals/schemas`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch schemas');
      }

      const data = await response.json();
      setSchemas(data.data || []);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleSchemaChange = (e) => {
    const schemaId = e.target.value;
    setSelectedSchema(schemaId);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const allowedTypes = ['.csv', '.xlsx', '.xls'];
      const fileExt = selectedFile.name.toLowerCase().substring(selectedFile.name.lastIndexOf('.'));
      
      if (!allowedTypes.includes(fileExt)) {
        setError('Please select a CSV or Excel file');
        return;
      }

      if (selectedFile.size > 10 * 1024 * 1024) { // 10MB limit
        setError('File size must be less than 10MB');
        return;
      }

      setFile(selectedFile);
      setError('');
    }
  };

  const handleUpload = async () => {
    if (!file || !selectedSchema) {
      setError('Please select a file and schema');
      return;
    }

    setUploading(true);
    setError('');
    setSuccess('');

    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('schema_id', selectedSchema);

      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/visuals/upload`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Upload failed');
      }

      setSuccess(`Successfully uploaded ${data.insertedCount} records`);
      setFile(null);
      document.getElementById('file-input').value = '';
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <SidebarLayout>
      <div className="visuals-container">
        <div className="visuals-content">
          {/* Upload Section */}
          <div className="visuals-section">
            <h2>Upload Data</h2>
            <div className="visuals-upload-form">
              <div className="visuals-form-group">
                <label>Select Schema:</label>
                <select 
                  value={selectedSchema} 
                  onChange={handleSchemaChange}
                  className="visuals-select"
                >
                  <option value="">Choose a schema...</option>
                  {schemas.map((schema) => (
                    <option key={schema.schema_id} value={schema.schema_id}>
                      {schema.table_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="visuals-form-group">
                <label>Select File:</label>
                <input
                  id="file-input"
                  type="file"
                  accept=".csv,.xlsx,.xls"
                  onChange={handleFileChange}
                  className="visuals-file-input"
                />
              </div>

              <button
                onClick={handleUpload}
                disabled={!file || !selectedSchema || uploading}
                className="visuals-upload-btn"
              >
                {uploading ? 'Uploading...' : 'Upload File'}
              </button>
            </div>

            {error && (
              <div className="visuals-error">
                {error}
              </div>
            )}

            {success && (
              <div className="visuals-success">
                {success}
              </div>
            )}
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
};

export default UploadPage;

